import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const VxConsultLogo = ({ size }) => (
  <LogoSvg
    $size={size}
    viewBox="0 0 246 72"
    role="img"
    aria-label="VX Consult"
  >
    <path d="M20 9h29l27 43H48L20 9Z" fill="#173324" />
    <path d="M91 9h32L76 62H45L91 9Z" fill="#39b54a" />
    <path d="M75 9h24L64 62H40L75 9Z" fill="#173324" opacity="0.98" />
    <path d="M95 62h31L103 32 88 49l7 13Z" fill="#39b54a" />
    <text
      x="125"
      y="47"
      fill="#173324"
      fontFamily="Arial, Helvetica, sans-serif"
      fontSize="30"
      fontWeight="700"
      letterSpacing="0"
    >
      consult
    </text>
  </LogoSvg>
);

VxConsultLogo.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg'])
};

VxConsultLogo.defaultProps = {
  size: 'md'
};

export default VxConsultLogo;

const LogoSvg = styled.svg`
  display: block;
  width: ${({ $size }) => {
    if ($size === 'sm') return '96px';
    if ($size === 'lg') return '170px';
    return '128px';
  }};
  height: auto;
  flex-shrink: 0;
`;
